import HttpRequest from './http_request'

class CentralProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_CENTRAL_API_URL)
  }

  async getServertime() {
    const { data } = await this.get('/', {
      function: 'get-server-time',
    })
    return data
  }
}

export default CentralProvider